export const filterMapping = {
  filterName: "filterBeVariable",
  kategoriSurat: "kategoriSurat",
  kategoriPupuk: "category",
  //
  jenisTanaman: "plantId",
  status: "status",
  poktan: "poktanId",
} as const;

export type FilterKey = keyof typeof filterMapping;

export type Option = { label: string; value: string };
